import { red } from '@mui/material/colors'

// Create a theme instance.
const theme = {
  typography: {
    fontSize: 13,
    fontFamily: [
      // "Lato",
      // 'Roboto',
      'Darker Grotesque',
      'Nunito',
      'Lato',
      // "Poppins",
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    button: {
      textTransform: 'none' as 'none',
    },
  },
  palette: {
    // primary: {
    //   main: "#755cbb",
    // },
    primary: {
      // main: "#556cd6",
      main: '#3B71FF',
    },
    secondary: {
      main: '#6CD654', // "#19857b"
    },
    error: {
      main: red.A400,
    },
    background: {
      default: '#fff',
    },
    text: {
      primary: '#464464',
    },
  },
}

export default theme
